import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { finalize, tap } from 'rxjs';
import { BaseComponent } from 'src/app/core/base/base.component';
import { ExcelErrorModel } from 'src/app/model/core/excel-error';
import { CommonAtcService } from './common.atc.service';

@Component({
  selector: 'ms-common-atc-upload-model',
  templateUrl: './common.atc-upload-modal.component.html',
})
export class CommonAtcUploadModelComponent extends BaseComponent {
  @ViewChild('atcUploadFile') atcUploadFile?: FileUpload;
  @Input() showDialog?: boolean;
  @Output() showDialogChange: EventEmitter<boolean> = new EventEmitter();
  @Output() onSuccess: EventEmitter<boolean> = new EventEmitter();

  protected setScreen = false;
  file?: File;
  saving = false;
  errors?: ExcelErrorModel[] | null;

  constructor(protected service: CommonAtcService) {
    super();
  }

  selectFile = ({ currentFiles }: any) => {
    this.file = currentFiles[0];
  };

  resetFileSelection = () => {
    this.atcUploadFile?.clear();
    setTimeout(() => {
      if (
        this.atcUploadFile &&
        this.atcUploadFile['el'] &&
        this.atcUploadFile['el']['nativeElement']
      ) {
        const el = this.atcUploadFile['el']['nativeElement'] as HTMLElement;
        const fileInput = el.querySelector(
          'input[type="file"]'
        ) as HTMLInputElement;
        if (fileInput) {
          fileInput.click();
        }
      }
    }, 250);
  };

  clearFile = () => {
    this.atcUploadFile?.clear();
  };

  uploadFile = () => {
    this.saving = true;
    this.errors = null;
    const service = this.service.uploadFile(this.file!).pipe(
      finalize(() => (this.saving = false)),
      tap({
        next: (res) => {
          if (res.errors && res.errors.length > 0) {
            const unique = [...new Set(res.errors.map((item) => item.detail))];
            this.errors = unique.map(
              (item) => ({ detail: item } as ExcelErrorModel)
            );
          } else {
            this.errors = null;
            this.onSuccess.emit(true);
            setTimeout(() => {
              this.showDialogChange.emit(false);
            }, 250);
          }
        },
      })
    );
    this.subscriptions.push(service.subscribe());
  };
}
